import React from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { useAppBaseUrl } from '../../providers/SupabaseProvider';

const TachoPDFViewer = ({ pdfUrl, show, theme = "light" }) => {
    const appBaseUrl = useAppBaseUrl();
    const colors = {
        light: {
            bg: '#f5f7fa',
            fg: '#1a202c',
            panel: '#ffffff',
            border: '#e2e8f0',
            blue: '#3b82f6'
        },
        dark: {
            bg: '#1a202c',
            fg: '#f7fafc',
            panel: '#2d3748',
            border: '#4a5568',
            blue: '#60a5fa'
        }
    };

    const colorScheme = colors[theme] || colors.light;

    return (
        <div style={{ 
            width: '100%', 
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            background: colorScheme.panel
        }}>
            <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                padding: '16px',
                borderBottom: `1px solid ${colorScheme.border}40`
            }}>
                <h3 style={{ color: colorScheme.blue, margin: 0 }}>
                    📄 Infringement PDF
                </h3>
                <button
                    onClick={() => show(false)}
                    style={{
                        background: 'transparent',
                        border: 'none',
                        color: colorScheme.fg,
                        fontSize: '24px',
                        cursor: 'pointer',
                        width: '32px',
                        height: '32px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    ×
                </button>
            </div>
            
            <div style={{ 
                flex: 1,
                backgroundColor: '#ddd',
                overflow: 'auto'
            }}>
                <Worker workerUrl={`${appBaseUrl || window.location.origin}/pdf.worker.min.js`}>
                    <Viewer 
                        fileUrl={pdfUrl}
                        defaultScale={1.5}
                    />
                </Worker>
            </div>
        </div>
    );
};

export default TachoPDFViewer;
